import {
  getNotificationsList,
  updateListNotifications,
  updatePage,
  updateNewNotifications,
  updateNumTotal,
} from 'src/reducers/notification'
import {
  getProcessList,
  updateListProcess,
  updateProcessingNumber,
  updatePageProcess,
  updateNumTotalProcess,
} from 'src/reducers/processing'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useRef, useState } from 'react'
import _, { cloneDeep } from 'lodash'
import { ajaxCall } from 'src/reducers/axios'
import keycloak from 'src/utils/keycloak'

// @mui
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Drawer from '@mui/material/Drawer'
import List from '@mui/material/List'
import { Button, Stack, Typography } from '@mui/material'

// components
import Iconify from 'src/components/iconify'
import { varHover } from 'src/components/animate'
import NotificationModal from 'src/components/notification/notification-modal'
import Scrollbar from 'src/components/scrollbar'
import Badge from '@mui/material/Badge'
import Tooltip from '@mui/material/Tooltip'
import { useSubscription } from 'react-stomp-hooks'
import PropTypes from 'prop-types'
import { getTableDataPageContent, getTableDataPaginated, reloadPageContent } from 'src/reducers/app'
import { showMessage } from 'src/reducers/message'
import NotificationItem from './notification-item'

// ----------------------------------------------------------------------

export default function NotificationButton( {section}) {
  useSelector((state) => state.app.appConfig)
  const dispatch = useDispatch()

  const { isLoggedIn } = keycloak

  let currentUrl = new URL(window.location.href)

  currentUrl = currentUrl.pathname

  currentUrl = currentUrl.substring(4, currentUrl.length)

  const pageContent = useSelector((state) => state.app.pageContent)

  const pagination = useSelector((state) => state.app.pagination?.page)

  const pageType = useSelector((state) => state.app.pageType)

  const listNotifications = useSelector((state) =>
    section === 'notification' ? state.notification.listNotifications : state.processing.listProcess
  )

  const newNotifications = useSelector((state) =>
    section === 'notification' ? state.notification.newNotifications : state.processing.newProcess
  )

  const page = useSelector((state) =>
    section === 'notification' ? state.notification.page : state.processing.page
  )

  const totalPages = useSelector((state) =>
    section === 'notification' ? state.notification.totalPages : state.processing.totalPages
  )

  const [openDrawer, setOpenDrawer] = useState(false)

  const [disabled, setDisabled] = useState(false)

  const [openModal, setOpenModal] = useState(false)

  const [selected, setSelected] = useState(null)

  const [currentModalAction, setModalAction] = useState(null)

  const showMore = () => {
    const newNodes = cloneDeep(listNotifications)

    if (page <= totalPages) {
      dispatch(
        ajaxCall({
          config: {
            url: section === 'processing' ? '/notification-service/processing' : '/notification-service/notification', // ???
            method: 'get',
            params: { page },
          },
          success: (res) => {
            res.data.elements.forEach((element) => {
              newNodes.push(element)
            })

            dispatch(section === 'processing' ? updatePageProcess(page + 1) : updatePage(page + 1))

            dispatch( section === 'processing' ? updateListProcess({elements : newNodes}) : updateListNotifications({elements : newNodes}))
          },
          error: () => {},
          activeLoading: false,
        })
      )
      if (page + 1 > totalPages) {
        setDisabled(true)
      }
    }
  }

  const readNotification = (elem, index) => {
    const newNodes = cloneDeep(listNotifications)
    const updateToNotifications = cloneDeep(newNotifications)

    if (!newNodes[index].read) {
      newNodes[index].read = true
      dispatch(updateListNotifications({ elements: newNodes }))

      dispatch(updateNewNotifications({ total: updateToNotifications - 1 }))

      dispatch(
        ajaxCall({
          config: {
            url: '/notification-service/notification/update',
            method: 'patch',
            params: {
              id: elem.id,
            },
          },
          success: () => {},
          error: () => {},
          activeLoading: false,
        })
      )
    }

  setSelected(index)

  setOpenModal(true)

  setModalAction(listNotifications[index])
  }

  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return
    }

    setOpenDrawer(open)

    if (!open) {
      dispatch(section === 'processing' ? updatePageProcess(2) : updatePage(2))

      setDisabled(false)

      if (openModal) {
        setOpenModal(false)
      }
    }
  }

  const readAll = () => {
    dispatch(
      ajaxCall({
        config: {
          url: '/notification-service/notification/readAll',
          method: 'patch',
        },
        success: () => {},
        error: () => {},
        activeLoading: false,
      })
    )

    setOpenDrawer(false)
  }

  const debouncedUpdateProcess = useRef(
    _.debounce((parsedMessage) => {
      dispatch(updateListProcess(parsedMessage))
      dispatch(updateProcessingNumber(parsedMessage))
      dispatch(updatePageProcess(parsedMessage.page + 1))
      dispatch(updateNumTotalProcess(parsedMessage.totalPages))
    }, 200)
  ).current


  useSubscription(`/${section}`, (message) => {
    const parsedMessage = JSON.parse(message.body)

    switch(section) {
      case 'processing':
        debouncedUpdateProcess(parsedMessage)

        break
      case 'notification': {
        dispatch(updateNewNotifications(parsedMessage))

        dispatch(updatePage(parsedMessage.page + 1))

        dispatch(updateNumTotal(parsedMessage.totalPages))

        dispatch(updateListNotifications(parsedMessage))

        const urlExist = parsedMessage.urlTableToUpdate ? parsedMessage.urlTableToUpdate.find(el => el.includes(currentUrl) && el.endsWith(currentUrl)) : undefined
        console.log("Current: ", currentUrl)
        console.log("urlExitsts: ", urlExist)
        console.log("PageType: ", pageType)
        if(urlExist){

          if(pageContent.tableData) {
            console.log("Tabella")
            dispatch(getTableDataPageContent(urlExist))
          } else if(pagination && (pageType === 'table' || pageType === 'multitable' || pageType === 'tableAjax')) {
            console.log("Tabella paginata")
            dispatch(getTableDataPaginated({ path: urlExist, pagination }))
          } else {
            dispatch(reloadPageContent(`${urlExist}/page`))
          }
        } else
          console.log("Nada")

        if(parsedMessage.urlTableToUpdate.length){
          dispatch(
            showMessage({
              message: 'Processo terminato',
              type: 'info',
              autoHide: true,
            })
          )
        }

        break
      }
      default:
        break
    }
  })

  const renderHead = (
    <Stack direction='row' alignItems='center' sx={{ py: 2, pl: 2.5, pr: 1, minHeight: 68 }}>
      <Typography variant='h6' sx={{ flexGrow: 1 }}>
        {section === 'notification' ? 'Notifiche' : 'In elaborazione'}
      </Typography>

      { section === 'notification' && (
        <Tooltip title='Segna tutte come lette'>
          <IconButton color='success' onClick={readAll}>
            <Iconify icon='eva:done-all-fill' />
          </IconButton>
        </Tooltip>
      )}
    </Stack>
  )

  const renderList = (
    <Box sx={{ width: 400 }} role='presentation'>
      {renderHead}

      {listNotifications && listNotifications.length ? (
        <div style={{ overflow: 'hidden' }}>
          <Scrollbar>
            <List disablePadding>
              {listNotifications.map((elem, index) => (
                <NotificationItem
                  notification={elem}
                  onClick={() => {
                    if (section === 'notification') {
                      readNotification(elem, index)
                    }}
                  }
                  key={index}
                  section={section}
                />
              ))}
            </List>
          </Scrollbar>
        </div>
      ) : (
        <Box sx={{ display: 'flex', justifyContent: 'center', my: 5 }}>
          <Typography variant='subtitle1'> {section === 'notification' ? 'Non sono presenti notifiche' : 'Nessuna elaborazione in corso'}</Typography>
        </Box>
      )}
    </Box>
  )

  useEffect(() => {
    if (isLoggedIn()) {
      dispatch(section === 'processing' ? getProcessList('/notification-service/processing') : getNotificationsList('/notification-service/notification'))
    }
  }, [dispatch, isLoggedIn, section])

  return (
    <>
      <IconButton
        whiletap='tap'
        whilehover='hover'
        aria-label='settings'
        onClick={toggleDrawer(true)}
        variants={varHover(1.05)}
      >
        <Badge
          hidden
          badgeContent={typeof newNotifications === "object"  ? newNotifications?.total : newNotifications}
          color='error'
          fontWeight='bold'
          sx={{ '& .MuiBadge-badge': { fontSize: 15, background: 'red' } }}
        >
          <Iconify icon={section === 'notification' ? 'solar:bell-bold-duotone' : "solar:clock-circle-bold"} width={24} />
        </Badge>
      </IconButton>

      <Drawer
        anchor='right'
        open={openDrawer}
        slotProps={{
          backdrop: { invisible: true },
        }}
        onClose={(e) => {
          setOpenDrawer(false)
          toggleDrawer(false)(e)
        }}
      >
        {renderList}

        {totalPages > 1 && (
          <Box sx={{ p: 1 }}>
            <Button
              fullWidth
              size='large'
              onClick={() => {
                showMore()
              }}
              disabled={totalPages === 1 ? true : disabled}
            >
              Mostra altro
            </Button>
          </Box>
        )}
      </Drawer>

      {section === 'notification' && selected !== null && currentModalAction && (
        <NotificationModal
          currentModalAction={currentModalAction}
          openModal={openModal}
          setOpenModal={setOpenModal}
          setSelected={setSelected}
          setOpenDrawer={setOpenDrawer}
          section={section}
        />
      )}
    </>
  )
}

NotificationButton.propTypes = {
  section: PropTypes.string,
}
